import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from 'images/icons/drop-arrow.svg';

const TrainingFAQItem = ({ question, answer }) => {
  const [isOpen, setOpen] = useState(false);

  function openChangeHandler() {
    setOpen(!isOpen);
  }

  return (
    <div className="single-faq">
      <button
        type="button"
        className="faq-heading button-unstyled"
        onClick={openChangeHandler}
      >
        <span className="question">{question}</span>
        <span className="faq-arrow">
          <ArrowIcon style={isOpen ? { transform: 'rotate(180deg)' } : {}} />
        </span>
      </button>

      <div className="faq-text" style={{ maxHeight: isOpen ? 900 : '' }}>
        {answer}
      </div>
    </div>
  );
};

TrainingFAQItem.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.oneOf(PropTypes.string, PropTypes.node, PropTypes.object),
};

export default TrainingFAQItem;
